import { Container } from "../Container";
import { ImageTexture } from "tree2d";
export class Picture extends Container {
    constructor(stage) {
        super(stage);
        this.tex = new ImageTexture(stage);
        this.el.texture = this.tex;
    }
    get src() {
        return this.tex.src;
    }
    set src(value) {
        this.tex.src = value;
    }
}
//# sourceMappingURL=Picture.js.map